import { contentLang } from './market'

/**
 * Localizes the GoalServe league/category names the match centers display — live
 * strings like "Atp - Singles: Us Open (Usa), Hard" or "Usa: Nfl" that never went
 * through the CMS translate module. They're structured (tour · draw: tournament,
 * surface / country: competition), so a token dictionary localizes them without a
 * per-name API round-trip. Only Spanish is filled (the embed pages are es); other
 * langs pass through unchanged. Word-boundary, case-insensitive; order matters
 * (longer phrases first).
 */
const ES: Array<[RegExp, string]> = [
  // Competitions with an established Spanish name. These run FIRST: a later
  // token rule would otherwise chew a word out of the phrase.
  [/\bSpanish Second Division\b/gi, 'Segunda División Española'],
  [/\bSpanish Cup\b/gi, 'Copa del Rey'],
  [/\bSpanish Super Cup\b/gi, 'Supercopa de España'],
  [/\bEuroleague\b/gi, 'Euroliga'],
  [/\bEurocup\b/gi, 'Eurocup'],
  [/\bDavis Cup\b/gi, 'Copa Davis'],
  [/\bBillie Jean King Cup\b/gi, 'Copa Billie Jean King'],
  [/\bWorld Group\b/gi, 'Grupo Mundial'],
  // Tennis tours / draws / surfaces
  [/\bAtp\b/gi, 'ATP'],
  [/\bWta\b/gi, 'WTA'],
  [/\bItf\b/gi, 'ITF'],
  [/\bMen\b/gi, 'Masculino'],
  [/\bWomen\b/gi, 'Femenino'],
  [/\bBoys\b/gi, 'Junior masc.'],
  [/\bGirls\b/gi, 'Junior fem.'],
  [/\bSingles\b/gi, 'Individual'],
  [/\bDoubles\b/gi, 'Dobles'],
  [/\bQualification\b/gi, 'Clasificación'],
  [/\bHard\b/gi, 'Pista dura'],
  [/\bClay\b/gi, 'Tierra batida'],
  [/\bGrass\b/gi, 'Hierba'],
  [/\bIndoor\b/gi, 'Indoor'],
  // Common stages
  [/\bPlay Offs?\b/gi, 'Play-offs'],
  [/\bWorld Championship\b/gi, 'Campeonato del Mundo'],
  [/\bWorld Cup\b/gi, 'Copa del Mundo'],
  [/\bFriendly\b/gi, 'Amistoso'],
  [/\bQualifiers?\b/gi, 'Clasificación'],
  // Countries / regions seen as "X:" prefixes across GoalServe sports
  [/\bUsa\b/gi, 'EE. UU.'],
  [/\bGermany\b/gi, 'Alemania'],
  [/\bSpain\b/gi, 'España'],
  [/\bItaly\b/gi, 'Italia'],
  [/\bFrance\b/gi, 'Francia'],
  [/\bBrazil\b/gi, 'Brasil'],
  [/\bFinland\b/gi, 'Finlandia'],
  [/\bDenmark\b/gi, 'Dinamarca'],
  [/\bSweden\b/gi, 'Suecia'],
  [/\bNorway\b/gi, 'Noruega'],
  [/\bTurkey\b/gi, 'Turquía'],
  [/\bGreece\b/gi, 'Grecia'],
  [/\bРussia\b/gi, 'Rusia'],
  [/\bCanada\b/gi, 'Canadá'],
  [/\bJapan\b/gi, 'Japón'],
  [/\bEurope\b/gi, 'Europa'],
  [/\bMexico\b/gi, 'México'],
  [/\bPortugal\b/gi, 'Portugal'],
  // A "(World)" region tag (Davis Cup, Billie Jean King Cup) reads as "mundial"
  // in Spanish; the bare word is left alone so "World Group"/"World Cup" above
  // keep their own phrasing.
  [/\(World\)/gi, '(Mundial)'],
]

export function localizeLeague(name: string | undefined, lang: string): string {
  if (!name) return ''
  if (contentLang(lang) !== 'es') return name
  let out = name
  for (const [re, to] of ES) out = out.replace(re, to)
  return out
}
